// extracted by mini-css-extract-plugin
export default {"modalButton":"modalButton_modalButton__R0sCO"};